"use client";

import Collapse from './Collapse';
export default Collapse;